import React, {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


//import useRadio from "../Assets/UseRadio";
import useInput from "../Assets/UseInput";
import {Trans, useTranslation} from "react-i18next";
import {Col, Alert, Form, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";

import BreadCrumb from "../Layout/BreadCrumb";
import * as moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/nl';
import 'moment/locale/en-gb'


var serialize = require('serialize-javascript');
var DatePicker = require("reactstrap-date-picker");

function PersonalDetails (props) {
    // fetch data from local Storage
    let history = useNavigate();
    const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const { i18n } = useTranslation();

    const nextLocation = {
        pathname: '../family',
        state: { d: d }
    }
    const handleNext = (e) =>{
        e.preventDefault()
        history(nextLocation)
    }

    const prevLocation = {
        pathname: '../information',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }

    // set control value and name to classic Inputs using the custom Hook useInput
    const {value: Field8Firstname, bind: bindField8Firstname, reset: setField8Firstname} = useInput('')
    const {value: Field7Name, bind: bindField7Name, reset: setField7Name} = useInput('')
    const {value: Field17CountryOther, bind: bindField17CountryOther, reset: setField17CountryOther} = useInput('')
    const {value: Field11AddressStreet, bind: bindField11AddressStreet, reset: setField11AddressStreet} = useInput('')
    const {value: Field11AddressStreetNumber, bind: bindField11AddressStreetNumber, reset: setField11AddressStreetNumber} = useInput('')
    const {value: Field11AddressStreetBox, bind: bindField11AddressStreetBox, reset: setField11AddressStreetBox} = useInput('')
    const {value: Field11AddressZip, bind: bindField11AddressZip, reset: setField11AddressZip} = useInput('')
    const {value: Field11AddressTown, bind: bindField11AddressTown, reset: setField11AddressTown} = useInput('')
    const {value: Field12Phone, bind: bindField12Phone, reset: setField12Phone} = useInput('')
    const {value: Field13GSM, bind: bindField13GSM, reset: setField13GSM} = useInput('')
    const {value: Field14Email, bind: bindField14Email, reset: setField14Email} = useInput('')
    const {value: Field15Bank, bind: bindField15Bank, reset: setField15Bank} = useInput('')
    const [Field9Birthdate, setField9Birthdate] = useState("");
    const [Field05Loss, setField05Loss] = useState("");
    const [Field10Sex, setField10Sex] = useState("");
    const [Field17CountryBelgium, setField17CountryBelgium] = useState("");
    const [Field16Civil, setField16Civil] = useState("");
    const [Age, setAge]= useState("")

    const [Field9BirthdateError, setField9BirthdateError]= useState(false)
    const [Field9BirthdateEarlierError, setField9BirthdateEarlierError]= useState(false)
    const [Field9BirthdateFormatError, setField9BirthdateFormatError]= useState(false)


    // Field05Loss Input custom handleChange
    const handleChangeField05Loss = (e) => {
        let value = e.target.value
        setField05Loss(value);
    }

    // Field10Sex Input custom handleChange
    const handleChangeField10Sex = (e) => {
        let value = e.target.value
        setField10Sex(value);
    }

    // Field17CountryBelgium Input custom handleChange
    const handleChangeField17CountryBelgium = (e) => {
        let value = e.target.value
        setField17CountryBelgium(value);
    }

    // Field16Civil Input custom handleChange
    const handleChangeField16Civil = (e) => {
        let value = e.target.value
       //console.log(value)
        setField16Civil(value);
    }

    const AgeCalculation = (e) => {
     //console.log(e.target.value)
        setField9Birthdate(e.target.value)
        let birthDate = moment(e.target.value, "YYYY-MM-DD")
        let validDate = moment(birthDate, 'YYYY-MM-DD', true).isValid()
        if (validDate) {
            let pastDate = birthDate.isBefore(moment())
            setField9BirthdateFormatError(false)
            if (!pastDate) {
                setField9BirthdateError(true)
                setField9BirthdateEarlierError(true)
            }else{
                setField9BirthdateEarlierError(false)
                setField9BirthdateError(false)
                let Age = !!moment().diff(birthDate, 'years', false)? moment().diff(birthDate, 'years', false): "0"
                setAge(Age)
            }
        }

    }
    const [stored, setStored] =  useState("")

    useEffect(() => {
                    window.scrollTo(0, 0)
        const fetchData = async () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
           //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            setIsLoading(false);
         //console.log(Field9Birthdate);


            const personalDetails = JSON.parse(localStorage.getItem('personalDetails'))

            if (personalDetails){
                setStored(true)
                setField8Firstname(personalDetails.Field8Firstname)
                setField7Name(personalDetails.Field7Name)
                setField9Birthdate(personalDetails.Field9Birthdate)
                setField17CountryOther(personalDetails.Field17CountryOther)
                setField11AddressStreet(personalDetails.Field11AddressStreet)
                setField11AddressStreetNumber(personalDetails.Field11AddressStreetNumber)
                setField11AddressStreetBox(personalDetails.Field11AddressStreetBox)
                setField11AddressZip(personalDetails.Field11AddressZip)
                setField11AddressTown(personalDetails.Field11AddressTown)
                setField12Phone(personalDetails.Field12Phone)
                setField13GSM(personalDetails.Field13GSM)
                setField14Email(personalDetails.Field14Email)
                setField15Bank(personalDetails.Field15Bank)
                setField05Loss(personalDetails.Field05Loss)
                setField10Sex(personalDetails.Field10Sex)
                setField17CountryBelgium(personalDetails.Field17CountryBelgium)
                setField16Civil(personalDetails.Field16Civil)
                setAge(localStorage.getItem("Age"))
            }
        };
        fetchData()
    }, []);




    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();

        let notValid = true
        // required empty fields

        if (d  ||  Age < 15){
            notValid = Field8Firstname === "" || Field7Name === "" || Field9Birthdate === "" || Field10Sex === "" || Field17CountryBelgium === "" || Field11AddressStreet === "" || Field11AddressZip === "" || Field11AddressTown === "" || Field16Civil === ""
           //console.log(Age < 15)
        }else{
            notValid = Field8Firstname === "" || Field7Name === "" || Field9Birthdate === "" || Field10Sex === "" || Field17CountryBelgium === "" || Field11AddressStreet === "" || Field11AddressZip === "" || Field11AddressTown === "" || Field16Civil === "" || Field05Loss === ""

        }

     //console.log(Field8Firstname === "" || Field7Name === "" || Field9Birthdate === "" || Field10Sex === "" || Field17CountryBelgium === "" || Field11AddressStreet === "" || Field11AddressZip === "" || Field11AddressTown === "" || Field16Civil === "" )
        setNotValid(notValid)
        if (!notValid){
            let personalDetails = {
                Field8Firstname: Field8Firstname,
                Field7Name: Field7Name,
                Field9Birthdate: Field9Birthdate,
                Field17CountryOther: Field17CountryOther,
                Field11AddressStreet: Field11AddressStreet,
                Field11AddressStreetNumber: Field11AddressStreetNumber,
                Field11AddressStreetBox: Field11AddressStreetBox,
                Field11AddressZip: Field11AddressZip,
                Field11AddressTown: Field11AddressTown,
                Field12Phone: Field12Phone,
                Field13GSM: Field13GSM,
                Field14Email: Field14Email,
                Field15Bank: Field15Bank,
                Field05Loss: Field05Loss,
                Field10Sex: Field10Sex,
                Field17CountryBelgium: Field17CountryBelgium,
                Field16Civil: Field16Civil,

            }
            //let stringInfo = JSON.stringify(personalDetails)
            let stringInfo = serialize(personalDetails, {isJSON: true});
            localStorage.setItem("personalDetails" , stringInfo)
            localStorage.setItem("Age" , Age)
           //console.log(JSON.parse(stringInfo))
            history(nextLocation)
        }

    }




    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div className={"container"}>
                    <TimeOutModal i18n={i18n} />
<BreadCrumb n={2}/>
                    <Row>
                        <Col>
                            <h3>{d?  i18n.t('DATATITLEDEATH') : i18n.t('DATATITLE') }</h3>

                            { NotValid &&
                            <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                            }
                            <Form>
                                <div className="formlevel01">
                                    <FormGroup>
                                        <Label for="Field8Firstname">{d? i18n.t("FIRSTNAMEDATADEATH") : i18n.t("FIRSTNAMEDATA")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} {...bindField8Firstname} placeholder={d? i18n.t("PLACEHOLDERFIRSTNAMEDATADEATH") : i18n.t("PLACEHOLDERFIRSTNAMEDATA")} invalid={(NotValid && Field8Firstname === "")}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="Field7Name">{d? i18n.t("NAMEDATADEATH") : i18n.t("NAMEDATA")} <span className={"text-danger"}>*</span></Label>
                                        <Input type="text" maxLength={500} {...bindField7Name} placeholder={d? i18n.t("PLACEHOLDERNAMEDATADEATH") : i18n.t("PLACEHOLDERNAMEDATA")} invalid={(NotValid && Field7Name === "")}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <div className={((NotValid && Field9BirthdateError)  || (NotValid && Field9BirthdateEarlierError) || (NotValid && Field9BirthdateFormatError))? "form-group text-danger" : "form-group"}>
                                        <Label for="Field9Birthdate">{i18n.t("BIRTHDATEDATA")} <span className={"text-danger"}>*</span></Label>
                                        <Input id={"field9birthdate"} value={Field9Birthdate}   onChange={AgeCalculation} type="date" invalid={(NotValid && Field9BirthdateError === true)}/>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        {(NotValid && Field9BirthdateEarlierError) && <p>{i18n.t("La date doit être dans le passé")}</p>}
                                        {(NotValid && Field9BirthdateFormatError) && <p>{i18n.t("La date n'est pas correctement encodée")} : {i18n.t("jj/mm/yyyy")} </p>}
                                    </div>
                                    <FormGroup>
                                        <Label for="Field10Sex" className={(NotValid && Field10Sex === "") ? "text-danger" : "text"}>{i18n.t("SEXDATA")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field10Sex" onChange={handleChangeField10Sex} value="man" checked={Field10Sex === "man"}/>
                                                &nbsp;{i18n.t("MAN")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field10Sex" onChange={handleChangeField10Sex} value="woman" checked={Field10Sex === "woman"}/>
                                                &nbsp;{i18n.t("WOMAN")}
                                            </Label>
                                        </div>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <FormGroup >
                                        <Label for="Field17CountryBelgium" className={(NotValid && Field17CountryBelgium === "") ? "text-danger" : "text"}>{d? i18n.t("Le défunt, habitait-il en Belgique?") : i18n.t("J'habite à l'étranger")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" onChange={handleChangeField17CountryBelgium} name="Field17CountryBelgium" value="yes" checked={Field17CountryBelgium === "yes"}/>
                                                &nbsp;{i18n.t("YES")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio"  onChange={handleChangeField17CountryBelgium}  name="Field17CountryBelgium" value="no" checked={Field17CountryBelgium === "no"}/>
                                                &nbsp;{i18n.t("NO")}
                                            </Label>
                                        </div>
                                        {Field17CountryBelgium === "no" &&
                                        <div className="formlevel02">
                                            <FormGroup>
                                                <Label for="Field17CountryOther">{i18n.t("Pays")} <span className={"text-danger"}>*</span></Label>
                                                <Input type="text" maxLength={500} {...bindField17CountryOther} placeholder={i18n.t("Indiquer le pays")} invalid={(NotValid && Field17CountryOther === "")}/>
                                                <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                            </FormGroup>
                                        </div>}
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>
                                    <div>
                                        <Label for="Field11Address">{i18n.t("ADDRESSDATA")}</Label>


                                        <FormGroup className="row py-0">
                                            <Label for="Field11AddressStreet" className={"col-sm-2"}>{i18n.t("field11AddressStreet")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField11AddressStreet} placeholder={i18n.t("field11AddressStreet")} invalid={(NotValid && Field11AddressStreet === "")? true : undefined}/>

                                        </FormGroup>
                                        <FormGroup className="row py-0">
                                            <Label for="Field11AddressStreetNumber" className={"col-sm-2"} invalid={(NotValid && Field11AddressStreetNumber === "")? true : undefined}>{i18n.t("field11AddressStreetNumber")} <span className={"text-danger"}>*</span></Label>

                                            <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField11AddressStreetNumber} placeholder={i18n.t("field11AddressStreetNumber")} invalid={(NotValid && Field11AddressStreetNumber === "")? true : undefined}/>

                                            <Label  for="Field11AddressStreetBox" className={"col-sm-2"} >{i18n.t("field11AddressStreetBox")}</Label>

                                            <Input type="text" maxLength={500} className={"col-sm-4"} {...bindField11AddressStreetBox} placeholder={i18n.t("field11AddressStreetBox")} />

                                        </FormGroup>
                                        <FormGroup className="row  py-0">
                                            <Label for="Field11AddressZip" className={"col-sm-2"}  invalid={(NotValid && Field11AddressZip === "") ? true : undefined}>{i18n.t("field11AddressZip")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField11AddressZip} placeholder={i18n.t("field11AddressZip")} invalid={(NotValid && Field11AddressZip === "") ? true : undefined}/>

                                        </FormGroup>
                                        <FormGroup className="row  py-0">
                                            <Label for="Field11AddressTown" className={"col-sm-2"} invalid={(NotValid && Field11AddressTown === "")? true : undefined}>{i18n.t("field11AddressTown")} <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className={"col-sm-10"} {...bindField11AddressTown} placeholder={i18n.t("field11AddressTown")} invalid={(NotValid && Field11AddressTown === "")? true : undefined}/>

                                        </FormGroup>
                                    </div>
                                    {!d &&
                                    <div>
                                        <FormGroup>
                                            <Label for="Field12Phone">{i18n.t("PHONEDATA")}</Label>
                                            <Input type="text" maxLength={500} {...bindField12Phone}
                                                   placeholder={i18n.t("PLACEHOLDERPHONEDATA")}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="Field13GSM">{i18n.t("GSMDATA")}</Label>
                                            <Input type="text" maxLength={500} {...bindField13GSM}
                                                   placeholder={i18n.t("PLACEHOLDERGSMDATA")} invalid={(NotValid && Field13GSM === "true")}/>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="Field14Email">{i18n.t("EMAILDATA")}</Label>
                                            <Input type="text" maxLength={500} {...bindField14Email}
                                                   placeholder={i18n.t("PLACEHOLDEREMAILDATA")}/>
                                            <div className="alert alert-info mt-2">
                                                <button type="button" className="close" data-dismiss="alert"
                                                        aria-hidden="true">×
                                                </button>
                                                <FontAwesomeIcon className="pre" icon={['fas', 'info-circle']} />&nbsp;
                                                <strong>{i18n.t("Attention")}</strong>
                                                <hr className="message-inner-separator"/>
                                                <p>{i18n.t("EmailWarning")}</p>
                                            </div>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="Field15Bank">{i18n.t("BANKDATA")}</Label>
                                            <Input type="text" maxLength={500} {...bindField15Bank}
                                                   placeholder={i18n.t("PLACEHOLDERBANKDATA")}/>
                                            <div className="alert alert-info mt-2">
                                                <button type="button" className="close" data-dismiss="alert"
                                                        aria-hidden="true">×
                                                </button>
                                                <FontAwesomeIcon className="pre" icon={['fas', 'info-circle']} />&nbsp;
                                                <strong>{i18n.t("Attention")}</strong>
                                                <hr className="message-inner-separator"/>
                                                <p>{i18n.t("BankWarning")}</p>
                                            </div>
                                        </FormGroup>
                                    </div>
                                    }
                                    <div>
                                        <FormGroup>
                                            <Label for="Field16Civil" className={(NotValid && Field16Civil === "") ? "text-danger" : "text"}>{i18n.t("CIVILDATA")} <span className={"text-danger"}>*</span></Label>
                                            <Input type={"select"} name="Field16Civil" onChange={handleChangeField16Civil} value={Field16Civil}>
                                                <option value=""> </option>
                                                <option value="single"  >{i18n.t("single")}</option>
                                                {(Age > 15) && <option value="maried" >{i18n.t("maried")}</option>}
                                                {(Age > 15) &&   <option value="cohabitant" >{i18n.t("cohabitant")}</option>}
                                                {(Age > 15) &&   <option value="cohabitantlegal">{i18n.t("cohabitant legal")}</option>}
                                                {(Age > 15) &&   <option value="widow"  >{i18n.t("widow")}</option>}
                                                {(Age > 15) &&   <option value="separated" >{i18n.t("separated")}</option>}
                                                {(Age > 15) &&   <option value="divorced" >{i18n.t("divorced")}</option>}

                                            </Input>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback></FormGroup>
                                    </div>

                                    {!d && Age > 15 &&
                                    <FormGroup >
                                        <Label for="Field05Loss" className={(NotValid && Field05Loss === "") ? "text-danger" : "text"}>{i18n.t("LOSSACCIDENT")} <span className={"text-danger"}>*</span></Label>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field05Loss"  onChange={handleChangeField05Loss}  value="no" checked={Field05Loss === "no"}/>
                                                &nbsp;{i18n.t("NO")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field05Loss" onChange={handleChangeField05Loss}  value="yes" checked={Field05Loss === "yes"}/>
                                                &nbsp;{i18n.t("YES")}
                                            </Label>
                                        </div>
                                        <div className="checkbox">
                                            <Label>
                                                <Input type="radio" name="Field05Loss" onChange={handleChangeField05Loss}  value="unknown" checked={Field05Loss === "unknown"}/>
                                                &nbsp;{i18n.t("Je ne sais pas encore")}
                                            </Label>
                                        </div>
                                        <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                    </FormGroup>}



                                    { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                </div>
                            </Form>

                            <span className={"text-danger"}>* </span> {  i18n.t('Renseignement indispensable') }<br />
                        </Col>
                    </Row>
                    
                </div>}
        </div>
    )
}
export default PersonalDetails

